var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpriteMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  y: 213,
  viewBox: "-10 -10 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E48",
  d: "m42 24.43-10.99 6.513a1 1 0 0 1-1.02 0L19 24.43V22.5a.5.5 0 0 1 .5-.5h22a.5.5 0 0 1 .5.5zm0 14.07a.5.5 0 0 1-.5.5h-22a.5.5 0 0 1-.5-.5V25.592l10.48 6.211a2 2 0 0 0 2.04 0L42 25.593zM41.5 21h-22a1.5 1.5 0 0 0-1.5 1.5v16a1.5 1.5 0 0 0 1.5 1.5h22a1.5 1.5 0 0 0 1.5-1.5v-16a1.5 1.5 0 0 0-1.5-1.5"
}))));
export default SvgSpriteMail;